import React, { useContext } from "react";
import { Grid, Image } from "semantic-ui-react";

import GlobalContext from "../../../../src/contexts/GlobalContext";
import Utility from "../../../../src/Utility";

import AmountProvider from "../../../components/Provider/AmountProvider";

const ExtraDetails = ({ supplement, quantity, currency }) => {
  const [globalContext] = useContext(GlobalContext) as any;
  return (
    <Grid style={{ height: "100%" }} columns="equal" padded>
      <Grid.Column textAlign="center" computer={6} mobile={16}>
        <Image ui centered src={Utility.imageExists(supplement.image)} />
      </Grid.Column>
      <Grid.Column style={{ margin: "auto" }} computer={10} mobile={16}>
        <div>
          <div>
            <h4>
              {supplement.name} x {quantity}
            </h4>
            <span className="price-type">
              {globalContext.translations.unitPrice}
            </span>
            <span style={{ fontSize: "0.85em" }}>
              <AmountProvider
                amount={supplement.price}
                currency={supplement.currency ?? currency}
              />
            </span>
            <p className="mt-2 description-text">{supplement.description}</p>
          </div>
          <div className="text-right mt-5">
            <h3>
              {globalContext.translations.total}:{" "}
              <AmountProvider
                amount={supplement.price * quantity}
                currency={supplement.currency ?? currency}
              />
            </h3>
          </div>
        </div>
      </Grid.Column>
    </Grid>
  );
};

export default ExtraDetails;
